import React, { useState } from 'react';
import ModalCloseButton from './ui/ModalCloseButton';

export default function EditPriceModal({
  item,
  onClose,
  onSave
}) {
  const [buyPrice, setBuyPrice] = useState(item?.buy_price ? String(item.buy_price).replace(/[^0-9]/g, '') : '');
  const [rentPrice, setRentPrice] = useState(item?.rent_price ? String(item.rent_price).replace(/[^0-9]/g, '') : '');

  const save = () => {
    const next = {
      buy_price: buyPrice ? `$${parseInt(buyPrice, 10)}` : null,
      rent_price: item?.rentable ? (rentPrice ? `$${parseInt(rentPrice, 10)}` : null) : null
    };
    onSave(next);
  };

  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4" onClick={onClose}>
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-8 animate-slide-up" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start justify-between mb-6">
          <div>
            <h3 className="text-2xl font-bold text-gray-900">Edit Prices</h3>
            <p className="text-sm text-gray-600 mt-1">{item?.name}</p>
          </div>
          <ModalCloseButton onClick={onClose} />
        </div>

        <div className="space-y-4">
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">Buy Price (whole dollars)</label>
            <div className="flex items-center gap-2">
              <span className="text-gray-500">$</span>
              <input
                type="text"
                inputMode="numeric"
                value={buyPrice}
                onChange={(e) => setBuyPrice(e.target.value.replace(/[^0-9]/g, ''))}
                placeholder="25"
                className="flex-1 h-11 px-4 bg-white border border-gray-300 rounded-md text-gray-900 placeholder-gray-400 focus:ring-2 focus:ring-primary focus:border-primary"
              />
            </div>
          </div>

          {item?.rentable && (
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">Rent Price (whole dollars)</label>
              <div className="flex items-center gap-2">
                <span className="text-gray-500">$</span>
                <input
                  type="text"
                  inputMode="numeric"
                  value={rentPrice}
                  onChange={(e) => setRentPrice(e.target.value.replace(/[^0-9]/g, ''))}
                  placeholder="30"
                  className="flex-1 h-11 px-4 bg-white border border-gray-300 rounded-md text-gray-900 placeholder-gray-400 focus:ring-2 focus:ring-primary focus:border-primary"
                />
              </div>
            </div>
          )}
        </div>

        <div className="flex gap-3 mt-8">
          <button
            onClick={onClose}
            className="flex-1 h-12 bg-gray-100 border border-gray-300 text-gray-700 font-semibold rounded-lg hover:bg-gray-200 transition"
          >
            Cancel
          </button>
          <button
            onClick={save}
            className="flex-1 h-12 bg-primary text-white font-semibold rounded-lg hover:bg-primary-dark transition"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
}
